import { ProfileService } from './../../../services/profile.services';
import {
  Component,
  AfterContentInit,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  OnInit,
  ElementRef,
  OnDestroy
} from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

import { PlycaDataService } from '../../../services/plyca.service';
import { UIService } from '../../ui.service';
import { documentsComponent } from '../../documents/documents.component';
import { emptyComponent } from '../../components/empty.component';
import { dossierBasicInfoComponent } from '../components/dossierBasicInfo.component';
import { DossierActionsComponent } from '../dossierActions/dossierActions.component';
import { AuditComponent } from '../audit/audit.component';
import { calendarComponent } from '../../calendar/calendar.component';
import { CommunicationsComponent } from '../communications/communications.component';
import { planningComponent } from '../planning/planning.component';
import {
  HelpService,
  HelpType
} from '../../components/common/help/help.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { accountingViewComponent } from '../accounting/accounting.component';
import { proceduresComponent } from '../procedures/procedures.component';
import { ContractsDemoComponent } from '../contracts/contractsDemo.component';
import { ProjectQuestionsComponent } from '../questions/project-questions.component';
import { TranslateService } from '@ngx-translate/core';
import { ServiceLocator } from '../../ServiceLocator';
import { Configuration } from '../../conf/app.constants';
import { PropertyDTO } from '../../api/plyca-dtos';
import { PropertyService } from '../../properties/property.service';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { AppConfiguration } from '../../conf/app.configuration';
import { UserService } from '../../user.service';
import { ContractsComponent } from '../contracts/contracts.component';
import { ContractsAYMADComponent } from '../../aymad/contracts/contractsAYMAD.component';
import { FrameworkAgreementSituationAYMADComponent } from '../../aymad/frameworkAgreementSituation/frameworkAgreementSituationAYMAD.component';
import { UnitPriceRelationDocumentComponentAYMAD } from '../../aymad/unitPriceRelationDocument/unitPriceRelationDocumentAYMAD.component';
import { ProcurementProjectDTO } from '../../api/plyca-dtos-v2';
import { catchError } from 'rxjs/operators';
import { DynamicPurchasingSystemAYMADComponent } from '../../aymad/dynamicPurchasingSystemSituation/dynamicPurchasingSystemAYMAD.component';

@Component({
  selector: 'dossierInfo',
  templateUrl: 'dossierInfo.template.html'
})
export class DossierInfoComponent extends BaseComponent implements OnInit, OnDestroy {
  dossierId: string;
  public dossier: any;
  public currentComponent: any;
  @ViewChild('infoContainer', { read: ViewContainerRef, static: true })
  infoContainer: ViewContainerRef;
  profileService: ProfileService;

  GENERAL_INFO = {
    id: 'GENERAL_INFO',
    short: 'DossierInfo.sections.GENERAL_INFO.short',
    name: 'DossierInfo.sections.GENERAL_INFO.name',
    iconClass: 'fa fa-lg fa-info-circle'
  };
  CONTRACTS = {
    id: 'CONTRACTS',
    short: 'DossierInfo.sections.CONTRACTS.short',
    name: 'DossierInfo.sections.CONTRACTS.name',
    iconClass: 'fas fa-lg fa-file-contract'
  };
  CONTRACTSAYMAD = {
    id: 'CONTRACTSAYMAD',
    short: 'DossierInfo.sections.CONTRACTS.short',
    name: 'DossierInfo.sections.CONTRACTS.name',
    iconClass: 'fas fa-lg fa-file-contract'
  };
  // CONTRACTS_DEMO = {
  //   id: 'CONTRACTS',
  //   short: 'Contratos (DEMO)',
  //   name: 'Contratos del expediente',
  //   iconClass: 'fas fa-lg fa-file-contract'
  // };
  DOCUMENTS = {
    id: 'DOCUMENTS',
    short: 'DossierInfo.sections.DOCUMENTS.short',
    name: 'DossierInfo.sections.DOCUMENTS.name',
    iconClass: 'fas fa-lg fa-file-alt'
  };
  DOSSIER_ACTIONS = {
    id: 'DOSSIER_ACTIONS',
    short: 'DossierInfo.sections.DOSSIER_ACTIONS.short',
    name: 'DossierInfo.sections.DOSSIER_ACTIONS.name',
    iconClass: 'fa fa-lg fa-tasks'
  };
  AUDIT = {
    id: 'AUDIT',
    short: 'DossierInfo.sections.AUDIT.short',
    name: 'DossierInfo.sections.AUDIT.name',
    iconClass: 'fas fa-lg fa-list-ul'
  };
  CALENDAR = {
    id: 'CALENDAR',
    short: 'DossierInfo.sections.CALENDAR.short',
    name: 'DossierInfo.sections.CALENDAR.name',
    iconClass: 'fa fa-lg fa-calendar'
  };
  COMMUNICATIONS = {
    id: 'COMMUNICATIONS',
    short: 'DossierInfo.sections.COMMUNICATIONS.short',
    name: 'DossierInfo.sections.COMMUNICATIONS.name',
    iconClass: 'fas fa-lg fa-envelope-open-text'
  };
  QUESTIONS = {
    id: 'QUESTIONS',
    short: 'DossierInfo.sections.QUESTIONS.short',
    name: 'DossierInfo.sections.QUESTIONS.name',
    iconClass: 'far fa-lg fa-question-circle'
  };
  PLANNING = {
    id: 'PLANNING',
    short: 'DossierInfo.sections.PLANNING.short',
    name: 'DossierInfo.sections.PLANNING.name',
    iconClass: 'fas fa-lg fa-clock'
  };
  PROCEDURES = {
    id: 'PROCEDURES',
    short: 'DossierInfo.sections.PROCEDURES.short',
    name: 'DossierInfo.sections.PROCEDURES.name',
    iconClass: 'fas fa-list-ul'
  };
  ACCOUNTING = {
    id: 'ACCOUNTING',
    short: 'DossierInfo.sections.ACCOUNTING.short',
    name: 'DossierInfo.sections.ACCOUNTING.name',
    iconClass: 'fas fa-euro-sign'
  };
  FRAMEWORKAGREEMENTSITUATIONAYMAD = {
    id: 'FRAMEWORKAGREEMENTSITUATIONAYMAD',
    short: 'Situación AM y CBAM',
    name: 'Situación AM y CBAM',
    iconClass: 'fas fa-file-contract'
  };
  DYNAMICPURCHASINGSYSTEMAYMAD = {
    id: 'DYNAMICPURCHASINGSYSTEMAYMAD',
    short: 'Situación SDA y CSDA',
    name: 'Situación SDA y CSDA',
    iconClass: 'fas fa-file-contract'
  };
  UNITPRICERELACIONDOCUMENTAYMAD = {
    id: 'UNITPRICERELACIONDOCUMENTAYMAD',
    short: 'Precios Unitarios',
    name: 'Precios Unitarios',
    iconClass: 'fas fa-file-excel'
  };


  items = [];


  itemsEXP = [
    this.GENERAL_INFO,
    this.DOSSIER_ACTIONS,
    this.CONTRACTS,
    this.CONTRACTSAYMAD,
    this.DOCUMENTS,
    this.ACCOUNTING,
    this.COMMUNICATIONS,
    this.QUESTIONS,
    this.PLANNING,
    this.PROCEDURES,
    this.AUDIT,
    this.CALENDAR,
    this.FRAMEWORKAGREEMENTSITUATIONAYMAD,
    this.DYNAMICPURCHASINGSYSTEMAYMAD,
    this.UNITPRICERELACIONDOCUMENTAYMAD
  ];

  itemsBASE = [
    this.GENERAL_INFO,
    this.DOSSIER_ACTIONS,
    this.CONTRACTS,
    this.CONTRACTSAYMAD,
    this.DOCUMENTS,
    this.COMMUNICATIONS,
    this.PROCEDURES,
    this.AUDIT,
    this.CALENDAR
  ];

  itemsOTHERS = [
    this.GENERAL_INFO,
    this.DOSSIER_ACTIONS,
    this.DOCUMENTS,
    this.COMMUNICATIONS,
    this.PROCEDURES,
    this.AUDIT,
    this.CALENDAR
  ];
  translateService: TranslateService;
  constructor(
    protected route: ActivatedRoute,
    public plycaService: PlycaDataService,
    public uiService: UIService,
    public helpService: HelpService,
    protected componentFactoryResolver: ComponentFactoryResolver,
    private headerActionsService: HeaderActionsService,
    private propertyServive: PropertyService,
    private elem: ElementRef,
    private location: Location,
    public router: Router,
    private configuration: Configuration,
    protected appConfig: AppConfiguration,
    private userService: UserService

  ) {
    super();
    this.subscribe(route.params, params => {
      this.dossierId = params['id'];
      this.initData();
    });

    this.translateService = ServiceLocator.injector.get(TranslateService);
    this.profileService = ServiceLocator.injector.get(ProfileService);
  }

  ngOnInit(): void {
    // this.initData();
  }

  initData() {

    this.subscribe(this.propertyServive.getProperty('VER_PREGUNTAS_LICITACION', '1'),
      (value: string) => {
        if (value === '0') {
          this.itemsBASE = this.itemsBASE.filter(element => element !== this.QUESTIONS);
          this.itemsEXP = this.itemsEXP.filter(element => element !== this.QUESTIONS);
        }
      })

    if (
      this.appConfig.getValue('calendar.enabled.profiles') !== undefined
      && !this.userService.hasRoles(this.appConfig.getValue('calendar.enabled.profiles'))
    ) {
      this.itemsBASE = this.itemsBASE.filter(element => element !== this.CALENDAR);
      this.itemsEXP = this.itemsEXP.filter(element => element !== this.CALENDAR);
    }

    let cliente = this.appConfig.getValue('cliente');
    if (cliente === 'AYMAD') {
      this.itemsBASE = this.itemsBASE.filter(element => element !== this.CONTRACTS);
      this.itemsEXP = this.itemsEXP.filter(element => element !== this.CONTRACTS);
    } else {
      this.itemsBASE = this.itemsBASE.filter(element => element !== this.CONTRACTSAYMAD);
      this.itemsEXP = this.itemsEXP.filter(element => element !== this.CONTRACTSAYMAD);
      this.itemsEXP = this.itemsEXP.filter(element => element !== this.FRAMEWORKAGREEMENTSITUATIONAYMAD);
      this.itemsEXP = this.itemsEXP.filter(element => element !== this.DYNAMICPURCHASINGSYSTEMAYMAD);
      this.itemsEXP = this.itemsEXP.filter(element => element !== this.UNITPRICERELACIONDOCUMENTAYMAD);
    }


    this.subscribe(this.plycaService.getDossier(this.dossierId), param => {
      this.dossier = param;

      if (this.dossier.division.documentClass.identifier === '00000') {
        if (cliente === 'AYMAD') {
          let complementarySystem = this.dossier?.idSistComplementario;
          if (complementarySystem === undefined)   {
            this.itemsEXP = this.itemsEXP.filter(element => element !== this.FRAMEWORKAGREEMENTSITUATIONAYMAD);
            this.itemsEXP = this.itemsEXP.filter(element => element !== this.UNITPRICERELACIONDOCUMENTAYMAD);
            this.itemsEXP = this.itemsEXP.filter(element => element !== this.DYNAMICPURCHASINGSYSTEMAYMAD);
          } else {
            if (complementarySystem.identifier === 'AM<>SISTCOMPLEMENTARIO'
              || complementarySystem.identifier === 'CBAM<>SISTCOMPLEMENTARIO') {
              this.itemsEXP = this.itemsEXP.filter(element => element !== this.DYNAMICPURCHASINGSYSTEMAYMAD);
            } else if (complementarySystem.identifier === 'CSDA<>SISTCOMPLEMENTARIO') {
              this.itemsEXP = this.itemsEXP.filter(element => element !== this.FRAMEWORKAGREEMENTSITUATIONAYMAD);
              this.itemsEXP = this.itemsEXP.filter(element => element !== this.UNITPRICERELACIONDOCUMENTAYMAD);
            }
          }
        }
        this.items = this.itemsEXP;
      } else if (this.dossier.division.documentClass.identifier === '03093' || this.dossier.division.documentClass.identifier === '02111'
        || this.dossier.division.documentClass.identifier === '00302') {
        this.items = this.itemsOTHERS;
      } else {
        // if (this.dossier.division.documentClass.identifier === '00600') {
        this.items = this.itemsBASE;
      }

      this.subscribe(this.route.queryParams, params => {
        // si no se especifica parametro se carga por defecto el general
        // this.currentComponent = this.items.find(comp => comp.id === params['component']) || this.GENERAL_INFO;
        // si no se especifica parametro se carga por defecto el primero
        this.currentComponent = this.items.find(comp => comp.id === params['component']);
        if (!this.currentComponent) {
          this.currentComponent = this.items[0];
        }
        this.loadComponent(this.currentComponent);
      });

      this.headerActionsService.setTaskDescription(
        this.elem,
        'DossierLinks.dossierInfo',
        'fas fa-tools',
        this.isLoaded.bind(this)
      );
      this.headerActionsService.setProject(this.elem, this.dossier, false);
    },
      (error: any) => {
        console.error('ERROR al consultar el expediente.');
        if (error.status === 403) {

          this.router.navigate(['accesoDenegado']);
        }

      }
    );
  }

  ngOnDestroy() {
    this.headerActionsService.clearActions();
    super.ngOnDestroy();
  }

  isLoaded(): boolean {
    return this.dossier != null;
  }

  loadComponent(option: any) {
    console.log('*****' + option);
    if (this.dossier != null && this.dossier.division != null && this.dossier.division.documentClass != null &&
      this.profileService.isOptionEnabled(option.id, this.dossier.division.documentClass.identifier)) {
      // console.log(this.profileService.isOptionEnabled(option));
      // limpiamos la carga de ayuda que pudiera estar almacenada previamente
      this.helpService.clearContextHelp();
      // // no recargamos si se pincha sobre el componente seleccionado
      // if (option === this.currentComponent) {
      //   return;
      // }
      this.infoContainer.clear();
      const childComponent = this.componentFactoryResolver.resolveComponentFactory(
        this.getComponentByType(option)
      );
      // at this point we want the "child" component to be rendered into the app.component:
      let instance = this.infoContainer.createComponent(childComponent).instance;
      instance['showHeader'] = false;



      // Se traslada aquí por que los componentes borrar los datos del header
      this.headerActionsService.setTaskDescription(
        this.elem,
        'DossierLinks.dossierInfo',
        'fas fa-tools',
        this.isLoaded.bind(this)
      );
      this.headerActionsService.setProject(this.elem, this.dossier, false);


      if (option === this.GENERAL_INFO) {
        this.subscribe(this.helpService.showContextHelpObservable([HelpType.DOSSIER_INFO]));
        instance['isPopup'] = false;
      } else if (option === this.DOSSIER_ACTIONS) {
        // La ayuda en el componente de acciones se carga en la logica interna
      } else if (option === this.AUDIT) {
        this.subscribe(this.helpService.showContextHelpObservable([HelpType.DOSSIER_AUDIT]));
      } else if (option === this.CALENDAR) {
        this.subscribe(this.helpService.showContextHelpObservable([HelpType.DOSSIER_CALENDAR]));
      } else if (option === this.COMMUNICATIONS) {
        this.subscribe(this.helpService.showContextHelpObservable([HelpType.DOSSIER_COMUNICATIONS]));
      } else if (option === this.DOCUMENTS) {
        this.subscribe(this.helpService.showContextHelpObservable([HelpType.DOSSIER_DOCUMENTS]));
      } else if (option === this.PLANNING) {
        this.subscribe(this.helpService.showContextHelpObservable([HelpType.DOSSIER_PLANNING]));
      } else if (option === this.PROCEDURES) {
        this.subscribe(this.helpService.showContextHelpObservable([HelpType.DOSSIER_PROCEDURES]));
      } else if (option === this.CONTRACTS) {
        this.subscribe(this.helpService.showContextHelpObservable([HelpType.DOSSIER_CONTRACTS]));
      } else if (option === this.ACCOUNTING) {
        this.subscribe(this.helpService.showContextHelpObservable([HelpType.EXPENSE_MANAGEMENT]));
      }

      // actualizar la referencia al componente actual para que funcione la navegacion
      this.currentComponent = option;
      this.location.replaceState(this.router.createUrlTree([],
        { /* Removed unsupported properties by Angular migration: skipLocationChange. */ relativeTo: this.route,
          queryParams: {
            component: this.currentComponent.id,
            divisionId: null,
          },
          queryParamsHandling: 'merge'
        }).toString()
      );
      // let actualURL = location.href;
      // if (actualURL.indexOf('?') > 0) {
      //   actualURL = actualURL.substring(0, actualURL.indexOf('?'));
      // }
      // actualURL += `?component=${this.currentComponent.id}`;
      // window.history.replaceState({}, '', actualURL);
    } else {
      this.router.navigate(['accesoDenegado']);
    }
  }
  isComponentSelected(componentName: string): boolean {
    return this.currentComponent === componentName;
  }

  getComponentByType(component: any): any {
    console.log('CARGANDO COMPONENTE: ' + component);
    switch (component) {
      case this.GENERAL_INFO:
        return dossierBasicInfoComponent;
      case this.CONTRACTS:
        return ContractsComponent;
      case this.CONTRACTSAYMAD:
        return ContractsAYMADComponent;
      case this.FRAMEWORKAGREEMENTSITUATIONAYMAD:
        return FrameworkAgreementSituationAYMADComponent;
      case this.DYNAMICPURCHASINGSYSTEMAYMAD:
        return DynamicPurchasingSystemAYMADComponent;
      case this.UNITPRICERELACIONDOCUMENTAYMAD:
        return UnitPriceRelationDocumentComponentAYMAD;
      // case this.CONTRACTS_DEMO:
      //   return ContractsDemoComponent;
      case this.DOCUMENTS:
        return documentsComponent;
      case this.DOSSIER_ACTIONS:
        return DossierActionsComponent;
      // case this.DOSSIER_ACTIONS2:
      //   return DossierActionsComponent;
      case this.AUDIT:
        return AuditComponent;
      case this.CALENDAR:
        return calendarComponent;
      case this.COMMUNICATIONS:
        return CommunicationsComponent;
      case this.QUESTIONS:
        return ProjectQuestionsComponent;
      case this.PLANNING:
        return planningComponent;
      case this.ACCOUNTING:
        return accountingViewComponent;
      case this.PROCEDURES:
        return proceduresComponent;
      default:
        return dossierBasicInfoComponent;
      //        return emptyComponent;
    }
  }
}
